import React from 'react'

export default (list = [], onClick) => {
  return list.map((item) => (
    <div className="slots__game" key={item.id} onClick={() => onClick(item)}>
      <div className="slots__game--img" title={item.name}>
        <img src={item.img} />
      </div>
      <div className="slots__game--name">{item.name}</div>
    </div>
  ))
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/games/slots/slotList.js